import React from 'react'

const Crew = () =>
  <div style={ { maxWidth: 670, color: '#666', margin: '30px auto 50px', padding: '0 30px' } }>
    Personal
  </div>

export default Crew
